import React, { useState, useEffect, useCallback  } from "react";
import WebchatButton from "./WebchatButton";
import { FaWhatsapp } from "react-icons/fa";
import { MdLocalPhone } from "react-icons/md";


export function Widgets() {
    return (
        <div>Widgets</div>
    )
}

export function Header() {

    const [menuVisible, setMenuVisible] = useState(false);

    useEffect(() => {
        // Cambiar clase en el body al abrir/cerrar el menú
        if (menuVisible) {
        document.body.classList.add("mobile-menu-visible");
        } else {
        document.body.classList.remove("mobile-menu-visible");
        }
        // Limpiar la clase si el componente se desmonta
        return () => {
        document.body.classList.remove("mobile-menu-visible");
        };
    }, [menuVisible]);

    // Funciones para abrir y cerrar el menú
    const openMenu = () => setMenuVisible(true);
    const closeMenu = () => setMenuVisible(false);

    return (
        <div>
            {/* <div class="loader-wrap">
                <div class="preloader"><div class="preloader-close"></div></div>
                <div class="layer layer-one"><span class="overlay"></span></div>
                <div class="layer layer-two"><span class="overlay"></span></div>        
                <div class="layer layer-three"><span class="overlay"></span></div>        
            </div> */}

            <header class="main-header header-style-one">
                <div class="header-upper">
                    <div class="auto-container">
                        <div class="inner-container clearfix">
                            <div class="logo-box">
                                <div class="logo"><a href="/"><img src="assets/images/logo.png" alt="" style={{width: '150px'}}/></a></div>
                            </div>
                            <div class="nav-outer clearfix">
                                <div class="mobile-nav-toggler" onClick={openMenu}><img src="assets/images/icons/icon-bar.png" alt=""/></div>
                                <nav class="main-menu navbar-expand-md navbar-light">
                                    <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                        <ul class="navigation clearfix">
                                            <li><a href="/">Inicio</a>
                                                
                                            </li>
                                            <li class="dropdown"><a href="#">Servicios</a>
                                                <ul>
                                                    <li><a href="/consultoria-en-desarrollo-organizacional">CONSULTORIA EN DESARROLLO ORGANIZACIONAL</a></li>
                                                    <li><a href="/cobranza-judicial-y-extrajudicial">COBRANZA JUDICIAL Y EXTRAJUDICIAL</a></li>
                                                </ul>
                                            </li> 
                                            
                                            <li><a href="/contacto">Contacto</a></li>

                                            <li style={{paddingTop:'0px'}}>
                                                <a href="https://wa.me/5540528188" class="theme-btn btn-style-four" style={{paddingTop:'0px', paddingBottom:'0px'}}>
                                                <span class="btn-title" style={{color:'#fff', background:'#cc9c4c'}}>
                                                <i class=""><MdLocalPhone/></i>LLAMANOS</span></a>
                                            </li>

                                            <li style={{paddingTop:'0px'}}>
                                                <a href="https://wa.me/5540528188" class="theme-btn btn-style-four" style={{paddingTop:'0px', paddingBottom:'0px'}}>
                                                <span class="btn-title" style={{color:'#fff', background:'#075e54'}}>
                                                <i class=""><FaWhatsapp/></i>CONTACTANOS</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sticky-header">
                    <div class="header-upper">
                        <div class="auto-container">
                            <div class="inner-container clearfix">
                                <div class="logo-box">
                                    <div class="logo"><a href="/"><img src="assets/images/logo.png" alt="" style={{width: '150px'}}/></a></div>
                                </div>
                                <div class="nav-outer clearfix">
                                    <div class="mobile-nav-toggler"><img src="assets/images/icons/icon-bar.png" alt=""/></div>
                                    <nav class="main-menu navbar-expand-md navbar-light">
                                        <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                            <ul class="navigation clearfix">
                                                <li>
                                                    <a href="/">Inicio</a>
                                                </li>
                                                <li class="dropdown"><a href="#">Servicios</a>
                                                    <ul>
                                                        <li><a href="/consultoria-en-desarrollo-organizacional">CONSULTORIA EN DESARROLLO ORGANIZACIONAL</a></li>
                                                        <li><a href="/cobranza-judicial-y-extrajudicial">COBRANZA JUDICIAL Y EXTRAJUDICIAL</a></li>
                                                    </ul>
                                                </li> 
                                                <li>
                                                    <a href="/contacto">Contacto</a>
                                                </li>

                                                                                                
                                                <li style={{paddingTop:'0px'}}>
                                                    <a href="https://wa.me/5540528188" class="theme-btn btn-style-four" style={{paddingTop:'0px', paddingBottom:'0px'}}>
                                                    <span class="btn-title" style={{color:'#fff', background:'#cc9c4c'}}>
                                                    <i class=""><MdLocalPhone/></i>LLAMANOS</span></a>
                                                </li>

                                                <li style={{paddingTop:'0px'}}>
                                                    <a href="https://wa.me/5540528188" class="theme-btn btn-style-four" style={{paddingTop:'0px', paddingBottom:'0px'}}>
                                                    <span class="btn-title" style={{color:'#fff', background:'#075e54'}}>
                                                    <i class=""><FaWhatsapp/></i>CONTACTANOS</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {menuVisible && (
                    <div className="mobile-menu">
                    <div className="menu-backdrop" onClick={closeMenu}></div>
                    <div className="close-btn" onClick={closeMenu}>
                        <span className="icon flaticon-remove"></span>
                    </div>

                    <nav className="menu-box">
                        <div className="nav-logo">
                        <a href="/"><img src="#" alt="" title=""/></a>
                        </div>
                        <div className="menu-outer"></div>

                        <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                            <ul class="navigation clearfix">
                                <li>
                                    <a href="/">Inicio</a>
                                </li>
                                    <li><a href="/consultoria-en-desarrollo-organizacional">CONSULTORIA EN DESARROLLO ORGANIZACIONAL</a></li>
                                    <li><a href="/cobranza-judicial-y-extrajudicial">COBRANZA JUDICIAL Y EXTRAJUDICIAL</a></li>
                                <li>
                                    <a href="/contacto">Contacto</a>
                                </li>
                            </ul>
                        </div>
                        
                    </nav>
                    </div>
                )}
                <div class="nav-overlay">
                    <div class="cursor"></div>
                    <div class="cursor-follower"></div>
                </div>
            </header>
            <WebchatButton/>
            {/* <a href="https://api.whatsapp.com/send?phone=5540528188" class="btn-wsp" target="_blank">
                <i class="fab fa-whatsapp"></i>
            </a> */}
        </div>
    )
}

export function Footer() {
    return(
        <div>
            <footer class="main-footer sp-two">
                <div class="auto-container">
                    <div class="footer-bottom">
                        <div class="row m-0 justify-content-between">
                            <ul class="menu">
                                <li><a href="assets/docs/aviso_de_privacidad_deudores.pdf" target="_blank">Aviso de privacidad </a></li>
                            </ul>
                            <div class="counter-title"><a style={{color: '#fff'}} href="https://goo.gl/maps/cjGTHESH5h5psfpMA?coh=178571&entry=tt">Avenida añil, Eje 3 Sur 571, colonia Granjas México, <br/>delegación Iztacalco, Ciudad de México, CDMX</a>
                        <br/><br/>
                        <i class="flaticon-phone"></i>  Telefono: <a style={{color: '#fff'}} href="tel:5588967448">(55) 8896-7448</a><br/>
                            </div>
                        </div>
                        <div class="copyright"><br/>Copyright © 2024  <a style={{color:' #c1a051'}} href="/">ADQUISICIONES & PASIVOS S.A DE C.V</a> </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export function AlertaPago() {  
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Pequeño delay para que la animación se note al cargar la página
        const timer = setTimeout(() => setIsVisible(true), 500);
        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) return null;

      // 📅 Fecha actual formateada DD/MM/YYYY
        const today = new Date();
        const currentDate = today.toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });

    const styles = {
        overlay: {
        position: 'fixed',
        bottom: '120px',
        right: '30px',
        width: '320px',
        backgroundColor: '#ffffff',
        borderRadius: '15px',
        boxShadow: '0px 10px 30px rgba(0,0,0,0.2)',
        padding: '25px',
        zIndex: 9999,
        border: '2px solid #8d6e32', // Color dorado similar al banner
        animation: 'slideInRight 0.5s ease-out',
        },
        title: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#363636', // Color verde oscuro del sitio
        marginBottom: '10px',
        display: 'block',
        textAlign: 'center'
        },
        text: {
        fontSize: '14px',
        color: '#555',
        lineHeight: '1.5',
        marginBottom: '15px'
        },
        companyName: {
        fontWeight: 'bold',
        color: '#8d6e32'
        },
        button: {
        backgroundColor: '#c3a253',
        color: 'white',
        border: 'none',
        padding: '8px 20px',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        width: '100%',
        transition: '0.3s'
        }
    };

    return (
        <>
        <style>
            {`
            @keyframes slideInRight {
                from { transform: translateX(100%); opacity: 0; }
                to { transform: translateX(0); opacity: 1; }
            }
            `}
        </style>
        <div style={styles.overlay}>
            <span style={styles.title}>¿Vas a realizar el pago de tu deuda?</span>
            <p style={styles.text}>
            Recuerda que la cuenta a donde deposites debe estar a nombre de: <br/>
            <span style={styles.companyName}>ADQUISICIONES & PASIVOS GWS, S.A. DE C.V. en el Banco BBVA.</span><br/><br/>
            <span><i>Importante: No contamos con cuenta STP ni depósitos a cuentas personales.</i></span>
            </p>
            <button 
            style={styles.button} 
            onClick={() => setIsVisible(false)}
            onMouseOver={(e) => e.target.style.backgroundColor = '#000'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#000'}
            >
            Entendido
            </button>
            <div style={{fontWeight:'600', textAlign:'center', fontSize:'14px'}}>
                Actualizado al {currentDate}
            </div>
        </div>
        </>
    );
}



export default Widgets